import React from "react";

export default function FacilityTypesSection() {
  const cards = [
    {
      title: "Government Facilities",
      desc: "Government-owned manufacturing and technology centres showcasing infrastructure and capabilities.",
      highlighted: true,
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0b1330" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 21h18" />
          <path d="M5 21V7l7-4 7 4v14" />
          <path d="M9 9h1M14 9h1M9 13h1M14 13h1M9 17h1M14 17h1" />
        </svg>
      ),
    },
    {
      title: "APIC Centres",
      desc: "APIC-affiliated centres managing facility, machines and prototype projects.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2l7 4v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-4z" />
          <path d="M9.5 12l2 2 3.5-3.5" />
        </svg>
      ),
    },
    {
      title: "Universities & Institutions",
      desc: "Engineering colleges and academic institutions listing laboratories and specialised equipment.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 9l10-5 10 5-10 5-10-5z" />
          <path d="M6 11v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5" />
          <path d="M22 9v6" />
        </svg>
      ),
    },
    {
      title: "R&D Centres",
      desc: "Research organisations showcasing advanced technologies and testing capabilities.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 2v6.5L4.5 17a2 2 0 0 0 1.8 3h11.4a2 2 0 0 0 1.8-3L15 8.5V2" />
          <path d="M9 2h6" />
          <path d="M8 15h8" />
        </svg>
      ),
    },
    {
      title: "MSMEs",
      desc: "Manufacturing MSMEs connecting available machine capacity with new prototype opportunities.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 21V10l6 4v-4l6 4V6l6 4v11H3z" />
        </svg>
      ),
    },
    {
      title: "Private Manufacturing Companies",
      desc: "Industrial companies offering specialised manufacturing and engineering services.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <path d="M9 9h.01M15 9h.01M9 15h.01M15 15h.01" />
        </svg>
      ),
    },
    {
      title: "Technology & Innovation Centres",
      desc: "Specialised technology centres showcasing unique capabilities and expertise.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8L12 3z" />
          <path d="M19 15l.7 1.7L21.5 17.5l-1.8.8L19 20l-.7-1.7-1.8-.8 1.8-.8L19 15z" />
        </svg>
      ),
    },
    {
      title: "Testing & Certification Labs",
      desc: "Laboratories offering testing, validation and certification capabilities.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <path d="M8 10h8M8 14h5" />
        </svg>
      ),
    },
    {
      title: "Tool Rooms & Fabrication",
      desc: "Tool rooms, fabrication facilities and specialised workshops registering their infrastructure.",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f7941d" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2-.6-.6-2 2.6-2.6z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="facility-section">
      <style>{`
        .facility-section {
          width: 100%;
          background: linear-gradient(180deg, #f4f7fc 0%, #eef1f8 100%);
          font-family: 'Inter', 'Segoe UI', sans-serif;
          box-sizing: border-box;
          padding: 30px 0;
        }
        .facility-wrap {
          width: 100%;
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 32px;
          text-align: center;
          box-sizing: border-box;
        }
        .facility-heading {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-weight: 800;
          font-size: clamp(1.7rem, 5vw, 3.1rem);
          letter-spacing: -0.02em;
          color: #0b1330;
          margin: 0;
        }
        .facility-accent { color: #f7941d; }
        .facility-subheading {
          margin-top: 18px;
          font-size: clamp(0.95rem, 2.2vw, 1.08rem);
          line-height: 1.7;
          color: #5a6280;
          max-width: 760px;
          margin-left: auto;
          margin-right: auto;
        }
        .facility-grid {
          margin-top: 48px;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 24px;
          text-align: left;
        }
        .facility-card {
          background: #ffffff;
          border: 1px solid #e7eaf3;
          border-radius: 18px;
          padding: 28px 24px;
          box-shadow: 0 20px 40px -30px rgba(11,19,48,0.15);
          box-sizing: border-box;
        }
        .facility-card--highlighted {
          border-color: #f7941d;
          box-shadow: 0 24px 48px -26px rgba(247,148,29,0.35);
        }
        .facility-icon-box {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          background: #0b1330;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 22px;
        }
        .facility-icon-box--highlighted {
          background: linear-gradient(135deg, #f7941d, #ef7f0e);
        }
        .facility-card-title {
          font-family: 'Sora', 'Segoe UI', sans-serif;
          font-weight: 700;
          font-size: 1.15rem;
          color: #0b1330;
          margin: 0;
        }
        .facility-card-desc {
          margin-top: 10px;
          font-size: 0.96rem;
          line-height: 1.6;
          color: #6b7290;
        }

        /* Tablet and below: allow 2 columns to breathe before auto-fit kicks in */
        @media (max-width: 720px) {
          .facility-section { padding: 48px 0; }
          .facility-wrap { padding: 0 20px; }
          .facility-grid { margin-top: 32px; gap: 18px; }
          .facility-card { padding: 24px 20px; }
        }

        /* Small phones: force a single column, tighten spacing */
        @media (max-width: 480px) {
          .facility-grid { grid-template-columns: 1fr; }
          .facility-card-title { font-size: 1.05rem; }
        }
      `}</style>

      <div className="facility-wrap">
        <h2 className="facility-heading">
          Built for every kind of <span className="facility-accent">facility.</span>
        </h2>
        <p className="facility-subheading">
          Government, academic, research and industrial — every facility with
          capacity to build has a place on APIC ProtoHub.
        </p>

        <div className="facility-grid">
          {cards.map((c, i) => (
            <div
              key={i}
              className={`facility-card ${c.highlighted ? "facility-card--highlighted" : ""}`}
            >
              <div
                className={`facility-icon-box ${c.highlighted ? "facility-icon-box--highlighted" : ""}`}
              >
                {c.icon}
              </div>
              <h3 className="facility-card-title">{c.title}</h3>
              <p className="facility-card-desc">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}